module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAI0lEQVR4AWMYHOCcoNp/cvBwMuA/eWBwGIAwgww8LAwYHgAAsEFQEHuWRnsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/YE.png
// module id = 1304
// module chunks = 0